import {
  Directive,
  ElementRef,
  HostListener,
  OnInit,
  DoCheck,
  Input,
} from '@angular/core';

@Directive({
  selector: '[giq-auto-resize]',
  standalone: false,
})
export class AutoResizeDirective implements OnInit, DoCheck {
  private lastValue: string = '';
  @Input() minSize = 10;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    if (this.elementRef.nativeElement.scrollHeight) {
      setTimeout(() => this.resize());
    }
    this.lastValue = this.elementRef.nativeElement.value;
  }

  ngDoCheck() {
    // Detectar cambios en el valor del input (incluyendo cuando se limpia con ngModel)
    if (this.elementRef.nativeElement.value !== this.lastValue) {
      this.lastValue = this.elementRef.nativeElement.value;
      this.resize();
    }
  }

  resize() {
    this.elementRef.nativeElement.style.height = '0';
    if (this.elementRef.nativeElement.scrollHeight > this.minSize) {
      this.elementRef.nativeElement.style.height =
        this.elementRef.nativeElement.scrollHeight + 'px';
    } else {
      this.elementRef.nativeElement.style.height = 'unset';
    }
  }
}
